// extracted by mini-css-extract-plugin
export default {"lds-ring":"lds-ring--u33Sr","ldsRing":"lds-ring--u33Sr","white":"white--iJRdK","red":"red--KPn34"};